/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Link_BuildersInputs */

const en_directory_footer_link_builders = /** @type {(inputs: Directory_Footer_Link_BuildersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builders`)
};

const zh_directory_footer_link_builders = /** @type {(inputs: Directory_Footer_Link_BuildersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开发者`)
};

/**
* | output |
* | --- |
* | "Builders" |
*
* @param {Directory_Footer_Link_BuildersInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_link_builders = /** @type {((inputs?: Directory_Footer_Link_BuildersInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Link_BuildersInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_link_builders(inputs)
	return zh_directory_footer_link_builders(inputs)
});
export { directory_footer_link_builders as "directory.footer.link_builders" }